import { createContext, type ReactNode, useContext } from 'react'
import type { BrowserResourceCapture } from '~/effects'

const BrowserResourceCaptureContext = createContext<BrowserResourceCapture | undefined>(undefined)

export function BrowserResourceBoundary({
  capture,
  children
}: {
  capture: BrowserResourceCapture
  children: ReactNode
}) {
  return (
    <BrowserResourceCaptureContext.Provider value={capture}>
      {children}
    </BrowserResourceCaptureContext.Provider>
  )
}

export function useCaptureBrowserResource(): BrowserResourceCapture {
  const capture = useContext(BrowserResourceCaptureContext)
  if (!capture) {
    throw new Error('BrowserResourceBoundary is missing')
  }
  return capture
}
